export default "__VITE_ASSET__DIXVHheA__"